import React from 'react';
import { defaultOperator, Select, TextInputProps } from '@fabric-ui/components';
import { ScoringMinus, ScoringPlus } from '@fabric-ui/icons';
import { iconSize } from '@fabric-ui/utils';
import { SxProps, TextFieldProps } from '@mui/material';
import { SchemaTypes } from '../../views/Sources/Mapping/types';
import { AdjustmentType, ScoreMode, ScoringFilter } from './types';

export const borderStyle = { borderRadius: 1, border: `1px solid var(--color-border-base-primary)` };

export const numberInputProps: (color?: string) => {
  disableClearButton?: TextInputProps['disableClearButton'];
  type?: TextFieldProps['type'];
  sx?: SxProps;
  size?: TextFieldProps['size'];
  inputProps?: TextInputProps['inputProps'];
} = color => ({
  size: 'small',
  disableClearButton: true,
  type: 'number',
  sx: { width: 90, color },
  inputProps: {
    sx: {
      color,
      fontWeight: 600,
      '&.MuiInputBase-root': { gap: '0px' },
    },
  },
});

export const Raise = (disabled = false) => (
  <ScoringPlus
    style={{
      color: disabled ? 'var(--color-surface-base-tertiary)' : 'var(--color-content-status-danger-secondary)',
      ...iconSize(16),
      zIndex: 1,
    }}
  />
);

export const Reduce = (disabled = false) => (
  <ScoringMinus
    style={{
      color: disabled ? 'var(--color-surface-base-tertiary)' : 'var(--color-content-status-success-secondary)',
      ...iconSize(16),
      zIndex: 1,
    }}
  />
);

export const EmptyStartAdornment = () => <ScoringMinus style={{ color: 'transparent', ...iconSize(16) }} />;

export const modeOptions = [
  { title: 'Reduce Score By', value: ScoreMode.REDUCE },
  { title: 'Raise Score By', value: ScoreMode.RAISE },
];

export const ModeSelect = ({
  mode,
  setMode,
  style,
  disabled,
}: {
  mode: ScoreMode;
  setMode: (mode: ScoreMode) => void;
  style: SxProps;
  disabled?: boolean;
}) => (
  <Select
    options={modeOptions}
    value={mode}
    onChange={v => setMode(v)}
    size="small"
    style={style}
    disabled={disabled}
    isRequired
    placeholder="Select Mode"
  />
);

export const getScoreCondition = (row: any, conditionType: SchemaTypes | string | undefined): string => {
  if (!row || !conditionType || !row.filter || !row.filter.expression) return '';
  const { addNullFilter, ...rest } = row.filter.expression[`${conditionType}Condition`];
  return Object.keys(rest).length > 0 ? Object.keys(rest)[0] : defaultOperator[`${conditionType}Condition`];
};

export const emptyFilter = (
  fieldName: string | undefined,
  conditionType: SchemaTypes,
  adjustmentType: AdjustmentType = 'MANUAL'
): ScoringFilter => ({
  score: 0,
  filter:
    adjustmentType === 'FIELD_BASED'
      ? null
      : {
          expression: {
            fieldName,
            [`${conditionType}Condition`]: { equals: '' },
          } as any,
        },
});

export const readOnlyInputSx = {
  '& .MuiOutlinedInput-notchedOutline': {
    backgroundColor: 'var(--color-surface-field-disabled)',
    border: 0,
  },
};
